import './instrument'
import React from 'react'
import dayjs from 'dayjs'
import {
	QueryClient,
	QueryClientProvider,
} from '@tanstack/react-query'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import './index.css'
import AppTheme from './AppTheme'
import reportWebVitals from './reportWebVitals'
import LanguageProvider from './contexts/LanguageContext'
import { LoanContextProvider } from './contexts/LoanContext'
import { AppProvider } from './components/AppContext/AppProvider'
import { addCustomYupValidators } from './services/yupValidation'
import { AlertsProvider } from './components/Alerts/AlertsProvider'
import { MixpanelProvider } from './components/MixPanel/MixPanelProvider'

import CustomBrowserRouter from './components/CustomBrowserRouter'

// Added to enable dayjs to parse dates with custom formats
// ToDo: Find another place to move it later
dayjs.extend(customParseFormat)

const queryClient = new QueryClient()

if (process.env.REACT_APP_ENV === 'development') {
	// eslint-disable-next-line no-underscore-dangle
	window.__TANSTACK_QUERY_CLIENT__ = queryClient
}

addCustomYupValidators()

if (
	localStorage.theme === 'dark' ||
	(!('theme' in localStorage) &&
		window.matchMedia('(prefers-color-scheme: dark)').matches)
) {
	localStorage.theme = 'dark'
	document.documentElement.classList.add('dark')
}

// @ts-ignore
const root = ReactDOM.createRoot(document.getElementById('root'), {
	onUncaughtError: Sentry.reactErrorHandler(),
	onCaughtError: Sentry.reactErrorHandler(),
	onRecoverableError: Sentry.reactErrorHandler(),
})

root.render(
	<React.StrictMode>
		<CustomBrowserRouter>
			<QueryClientProvider client={queryClient}>
				<AppProvider>
					<LoanContextProvider>
						<LanguageProvider>
							<MixpanelProvider>
								<AlertsProvider>
									<AppTheme />
								</AlertsProvider>
							</MixpanelProvider>
						</LanguageProvider>
					</LoanContextProvider>
				</AppProvider>
			</QueryClientProvider>
		</CustomBrowserRouter>
	</React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
